import React from "react";
import * as PropTypes from "prop-types";
import {ItemSlot} from "./Boilerplate/ItemSlot";
import {CharacterBackground} from "./Boilerplate/CharacterBackground";
import {ClearAllButton} from "./ClearAllButton";

const coordinates = {
  head: {top: 70, left: 400},
  body: {top: 190, left: 395},
  weapon: {top: 310, left: 270},
  wing: {top: 70, left: 300},
  ring: {top: 310, left: 515},
};

export const CharacterEquipment = props => <div id="equipment" style={{...props.style}}>
  <CharacterBackground/>
  {Object.values(props.equipped).filter(i => i).length ?
    <ClearAllButton handleClearItems={props.handleClearItems}/> :
    null}
  {["head", "body", "weapon", "wing", "ring"].map(slot =>
    <ItemSlot slot={slot} {...coordinates[slot]} {...props}/>)}
</div>;

CharacterEquipment.propTypes = {
  equipped: PropTypes.any,
  character: PropTypes.shape({
    head: PropTypes.arrayOf(PropTypes.string),
    body: PropTypes.arrayOf(PropTypes.string),
    weapon: PropTypes.arrayOf(PropTypes.string),
    ring: PropTypes.arrayOf(PropTypes.string),
    wing: PropTypes.arrayOf(PropTypes.string),
  }),
  handleSelectItem: PropTypes.func,
  handleClearItems: PropTypes.func
};